import {
  AuditFormFlowControl,
  AuditFormFlowLocateErrorControl,
} from "../common/auditFlowUtils";
export default {
  mixins: [$mixins.formControl],
  inject: {
    $formPickUp: {
      default: null,
    },
  },
  props: {
    caption: {
      type: String,
      default: "audit_state1",
    },
    // 元数据
    metadata: {
      type: Object,
      default() {
        let md = dsf.metadata.get("big-text-meta-data");
        return md;
      },
    },
    openFill: {
      default: true,
    },
    openWebValidate: {
      default: false,
    },
    openRealTimeCompute: {
      default: true,
    },
    // 保存前计算一次
    formSaveBeforeCompute: {
      default: false,
    },
  },
  data() {
    return {
      errorList: [],
    };
  },
  computed: {
    isAuditDesigner() {
      return !!this?.$formPickUp || this.queryString.is_audit_designer == 1;
    },
    isOpenFill() {
      if (this.queryString.disable_audit_fill == 1) return false;
      return this.openFill;
    },
  },
  methods: {
    initFillJs() {
      let path = getModuleName(
        "fill",
        "ev",
        this.$vm.nameSpace,
        this.$vm.pageName
      );
      path = dsf.config.serverCreateHtmlDir + path;
      if (this.customEvJsPath) {
        path = this.customEvJsPath;
      }
      let loading = dsf.layer.loading();
      try {
        dsf.require(
          {
            urlArgs: "_t=" + new Date().getTime(),
          },
          [path],
          (ev) => {
            let i = 0;
            if (ev && ev.expressions.length) {
              ev.expressions.forEach(
                ({ sub_expressions, rule_code, formula_id }) => {
                  sub_expressions.forEach((item) => {
                    if (item.is_disable == 1) {
                      return;
                    }
                    i++;
                    this.auditFormFlowControl.useAuditFormFlow(
                      {
                        formula_id,
                        id: `${rule_code}-${dsf.uuid()}`,
                        expression: item.js_expression || "",
                        jsFieldMap: item.js_field_map || {},
                        mainTableName: this.$vm.nameSpace.replace(/\./g, "_"),
                        crossTableData: Object.assign(
                          {},
                          this.$vm.$viewInitData?.fillData?.[formula_id] || {},
                          {
                            subTableData:
                              this.$vm.$viewInitData?.fillData?.subTableData ||
                              {},
                          }
                        ),
                      },
                      {
                        openRealTimeCompute: this.openRealTimeCompute,
                      }
                    );
                  });
                }
              );
            }
            this.isUseAuditFormFlowEnd = true;
            dsf.layer.closeLoading(loading);
          },
          (err) => {
            console.error(err);
            dsf.layer.closeLoading(loading);
          }
        );
      } catch (error) {
        console.error(error);
        dsf.layer.closeLoading(loading);
      }
    },
    initAuditJs() {
      let path = getModuleName(
        "audit",
        "ev",
        this.$vm.nameSpace,
        this.$vm.pageName
      );
      path = dsf.config.serverCreateHtmlDir + path;
      if (this.customEvJsPath) {
        path = this.customEvJsPath;
      }
      let loading = dsf.layer.loading();
      try {
        dsf.require(
          {
            urlArgs: "_t=" + new Date().getTime(),
          },
          [path],
          (ev) => {
            if (ev && ev.expressions.length) {
              ev.expressions.forEach((express) => {
                const {
                  sub_expressions,
                  rule_code,
                  formula_id,
                  is_open,
                } = express;
                sub_expressions.forEach((item) => {
                  if (is_open != 1) return;
                  let clarifyWay = [];
                  try {
                    clarifyWay = JSON.parse(express.clarifyWay);
                  } catch (error) {
                    console.error(error);
                  }
                  let opt = {
                    id: `${rule_code}-${dsf.uuid()}`,
                    formula_id,
                    rule_code: rule_code,
                    execute_order: express.execute_order,
                    err_hint: express.err_hint,
                    rule_name: express.rule_name,
                    verify_type_text: express.verify_type_text,
                    verify_type_value: express.verify_type_value,
                    clarifyWay,
                    clarifyValue: express.clarifyValue,
                    expression: item.js_expression || "",
                    jsFieldMap: item.js_field_map || {},
                    mainTableName: this.$vm.nameSpace.replace(/\./g, "_"),
                    crossTableData:
                      this.$vm.$viewInitData?.fillData?.[formula_id] || {},
                  };
                  this.auditFormFlowControl.useAuditFormFlowValidate(opt);
                });
              });
              this.$form.auditV2ValidateFn = this.auditV2ValidateFn;
            }
            dsf.layer.closeLoading(loading);
          },
          (err) => {
            console.error(err);
            dsf.layer.closeLoading(loading);
          }
        );
      } catch (error) {
        console.error(error);
        dsf.layer.closeLoading(loading);
      }
    },
    openErrorListPanel() {},
    closeErrorListPanel() {},
    runValidateAll() {
      let errorRemarkMap = {};
      this.errorList.forEach((item) => {
        errorRemarkMap[item.ruleId] = item.errInfo;
      });
      let res = this.auditFormFlowControl.runValidateAll();
      let openListPanel;
      res.forEach((item) => {
        item.errInfo = errorRemarkMap[item.ruleId] || null;
        let row = item;
        let isShowText;
        if (row.clarifyValue == 2) {
          if (row.clarifyWay.length) {
            let state = false;
            row.clarifyWay.forEach((it) => {
              if (it.way_state == 1) {
                state = true;
              }
            });
            isShowText = state;
          }
        } else {
          if (
            (row.verifyTypeValue == "B" && row.demotion) ||
            row.verifyTypeValue == "C" ||
            row.verifyTypeValue == "D"
          ) {
            isShowText = true;
          }
        }
        if (row.verifyTypeValue == "A" || (isShowText && !item.errInfo)) {
          openListPanel = true;
        }
      });
      console.log(res);
      this.setErrorList(res);
      this.emitValueChange(JSON.stringify(res));
      if (openListPanel && res.length) {
        this.$nextTick(() => {
          this.openErrorListPanel();
        });
        throw {
          message: "审核校验错误",
          result: res,
          type: "ValidateError",
        };
      }
    },
    runAuditFormFlowAllWatchCall() {
      try {
        if (!this.isUseAuditFormFlowEnd) return;
        this.auditFormFlowControl.runAuditFormFlowAllWatchCall();
      } catch (error) {
        console.error(error);
      }
    },
    setErrorList(errorList) {
      this.errorList = errorList || [];
      this.auditFormFlowLocateErrorControl.init({
        auditList: this.errorList,
      });
    },
    async auditV2ValidateFn(options) {
      return this.runValidateAll();
    },
    errorClick(row) {
      this.auditFormFlowLocateErrorControl.locateAudit(row.auditErrorId);
      this.closeErrorListPanel();
    },
    postBefore() {
      return new Promise((resolve, reject) => {
        (async () => {
          if (this.formSaveBeforeCompute) {
            this.runAuditFormFlowAllWatchCall();
          }
          Vue.nextTick(() => {
            resolve();
          });
        })();
      });
    },
  },
  watch: {
    "$vm.$isReady": {
      handler(v) {
        if (v && this.isOpenFill && !this.isInitFillJs) {
          if (this.isDesign || this.isAuditDesigner || this.readOnly) {
            return;
          }
          this.isInitFillJs = true;
          this.initFillJs();
        }
        if (v && this.openWebValidate && !this.isInitAuditJs) {
          if (this.isDesign || this.isAuditDesigner || this.readOnly) {
            return;
          }
          this.isInitAuditJs = true;
          this.initAuditJs();
        }
      },
    },
  },
  created() {
    if (this.isDesign || this.isAuditDesigner) {
      return;
    }
    this.auditFormFlowControl = new AuditFormFlowControl(this.$form, this.$vm);
    this.auditFormFlowLocateErrorControl = new AuditFormFlowLocateErrorControl(
      this.auditFormFlowControl,
      {}
    );
  },
  mounted() {},
  beforeDestroy() {
    this.auditFormFlowControl && this.auditFormFlowControl.unIinit();
    this.auditFormFlowLocateErrorControl &&
      this.auditFormFlowLocateErrorControl.unIinit();
  },
};

function getModuleName(fileName, client, ns, pn) {
  let opt = { client, ns, pn };
  // 因为移动端需要处理兼容问题 交由移动端项目自己处理
  dsf?.formulaAuditStateInitEvGetModuleNameBefore?.(opt);
  let info = splitNameSpace(opt.ns);
  return (
    opt.client +
    "/" +
    info.path +
    "/" +
    opt.pn +
    "." +
    fileName +
    ".js"
  ).replace(/(\/\/)/g, "/");
}
//切割nameSpace
function splitNameSpace(nameSpace) {
  if (nameSpace.startsWith(".")) {
    nameSpace = nameSpace.substr(1);
  }
  let arr = nameSpace.split(".");
  let fileName = arr[arr.length - 1];
  let path = arr.slice(0, arr.length).join(".");
  let ns = arr.slice(0, arr.length - 1).join(".");
  return {
    path: path,
    file: fileName,
    ns: ns,
  };
}
